var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded && _vm.Highcharts)?_c('Chart',{attrs:{"highcharts":_vm.Highcharts,"constructor-type":"mapChart","options":_vm.chartOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }